<template>
<div>
    <el-menu
            :default-active="index"
            class="fzs-menu"
            mode="horizontal"
            @select="handleSelect"
            background-color="#AF441E"
            text-color="#fff"
            active-text-color="#ffd04b">
        <el-submenu index="0" disabled>
            <template slot="title" disabled>
                <iframe width="300" scrolling="no" height="60" frameborder="0" allowtransparency="true" src="http://i.tianqi.com/index.php?c=code&id=12&icon=2&num=2&site=12"></iframe>
            </template>
        </el-submenu>
        <el-menu-item index="1"><router-link to="/">{{$t('index')}}</router-link></el-menu-item>
        <el-menu-item index="2"><router-link to="/it">{{$t('it')}}</router-link></el-menu-item>
        <el-menu-item index="3"><router-link to="/diary">{{$t('diary')}}</router-link></el-menu-item>
        <el-menu-item index="4"><router-link to="/test">{{$t('test')}}</router-link></el-menu-item>
        <el-menu-item index="5"><router-link to="/me">{{$t('me')}}</router-link></el-menu-item>
        <el-submenu index="6" disabled>
            <template slot="title" disabled>
                <el-button type="primary" icon="el-icon-search" @click="isSearch = true">{{$t('search')}}</el-button>
            </template>
        </el-submenu>
        <el-submenu index="7" disabled>
            <template slot="title" disabled>
                <el-switch
                        v-model="isZh"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-text="Language/English"
                        inactive-text="语言/中文">
                </el-switch>
            </template>
        </el-submenu>

    </el-menu>
    <el-dialog :title="$t('search')" :visible.sync="isSearch" :fullscreen="true" center>
        <div style="text-align: center">
            <el-autocomplete :placeholder="$t('input')" :disabled="isAble" v-model="keyword" @select="handleSearch" :fetch-suggestions="querySearchAsync" class="input-with-select" prefix-icon="el-icon-edit" clearable>
                <el-select v-model="select" slot="prepend" :placeholder="$t('select')" style="width: 140px;">
                    <el-option :label="$t('articletitle')" value="1"></el-option>
                    <el-option :label="$t('articlecon')" value="2"></el-option>
                </el-select>
                <el-button type="primary" slot="append" icon="el-icon-search" @click="isCanSearch"></el-button>
            </el-autocomplete>
        </div>
    </el-dialog>
</div>
</template>

<script>
    import common from '../../config/common.js';

    export default {
        name: "BlogHeader",
        data () {
            return {
                year:getYear(),
                isZh:true,
                isSearch:false,
                isAble:false,
                select:'',
                keyword:'',
                search:'',
                timeout:  null,
                list:[]
            }
        },methods:{
        handleSelect(key, keyPath) {
                    var url = ['',"/","/it","/diary","/test","/me"];
                    this.$router.push({path:url[key]})
                },querySearchAsync(queryString, cb) {
                if(this.$cookie.get('search')<0){
                    this.$message({
                        message: this.$t('notsearch'),
                        type: 'warning'
                    });
                    this.isAble = true;
                    return false;
                }
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {

                        if(this.$cookie.get('search')){
                            this.$cookie.set('search',this.$cookie.get('search')-1, 1)
                        }else {
                            this.$cookie.set('search',10, 1)
                        }
                        if(!queryString)return false;

                        this.$axios.post(common.apiurl+'/api/search',"keyword="+queryString).then((response)=>{
                            if(response.data.code==0){

                                if(response.data.data.length==0){
                                    this.$message({
                                        message: this.$t('nodata'),
                                        type: 'warning'
                                    });
                                    return false;
                                }
                                this.list = response.data.data.map(function(item) {
                                    return {
                                        id: item.id,
                                        value: item.title
                                    }
                                });
                                cb(this.list);
                            }
                            else {
                                if(response.data.msg){
                                    this.$message({
                                        message: response.data.msg,
                                        type: 'warning'
                                    });
                                }else{
                                    this.$message({
                                        message: this.$t('common.neterror'),
                                        type: 'warning'
                                    });
                                }
                            }
                        }).catch((error)=>{
                            this.$message({
                                message: this.$t('common.neterror'),
                                type: 'warning'
                            });
                        });
                }, 3000 * Math.random());
                },handleSearch(item){
                    this.isSearch = false;
                    this.$router.push({path:'/detail/'+item.id});
                },isCanSearch(){
                    if(this.$cookie.get('search')<0){
                        this.$message({
                            message: this.$t('notsearch'),
                            type: 'warning'
                        });
                        return false;
                    }
                }
        },
        props:['index'],
        watch: {
            isZh(val) {
                var lang = val?'zh':'en';
                this.$cookie.set('language', lang, 7);
                lang === 'en' ? this.$i18n.locale = 'en' : this.$i18n.locale = 'zh'
            }
        },created(){
            if(this.$cookie.get('language')=='en')this.isZh = 'false';
            if(this.$cookie.get('search')<0){
                this.isAble = true;
            }
        }

    }
    function getYear(){
        var date = new Date();
        return date.getFullYear();
    }
</script>

<style scoped>

.el-menu{
    position:fixed;
    z-index:1005;
    top:0;
    width: 100%;
  }
  .el-menu.el-menu--horizontal{
        border-bottom:none;
  }
    a{
        font-size: 13.5px;
        color: #817F7F;
        text-decoration:none;
        font-weigh:lighter;
    }
    a:hover{
        color: white;
        text-decoration:none;
        font-weigh:lighter;
    }
    .fzs-menu >>> .el-icon-search{
        color: inherit;
    }
</style>



// WEBPACK FOOTER //
// src/components/common/BlogHeader.vue